<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4znrCe/tc-custom/9781035875511.jpg?1746356845368" alt="This image is the cover for the book James Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">James Stories
      </h1>
      <p class="bookDescription body article font2">
        <p>Embark on a Journey Through Time and Miracles This idea came to me in the picturesque landscape of Kashubia. At first it seemed somewhat unconventional, but that only fueled the enthusiasm for its realisation. Imagine blending contemporary characters and events with the fascinating stories and figures from the medieval Codex Calixtinus, a book chronicling twenty-two miracles of the Saint James the Apostle. Each miracle was meticulously verified for authenticity, providing a captivating backdrop for this novel. Enter Michael, a 35-year-old with a keen eye and a sceptical mind, representing the modern world with all its knowledge and prejudices. Michael, a well-travelled corporate professional finds himself mysteriously transported to the Middle Ages. Will Michael’s modern approach and analytical thinking clash with medieval world, or will he find a deeper connection that transcends time? This spellbinding adventure intertwines the present with the past, inviting readers to explore the timeless power of faith and the enduring spirit of the Camino de Santiago.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Berenika Seryczyńska
      </h2>
      
      <p class="authorDescription body article">Berenika Seryczynska obtained her PhD on the topic of the Camino de Santiago (the Way of St. James), an adventure that began in 2013 when, setting off from Porto, she took a large rubbish bag with her instead of a rain cape. A year later, after coming across an advertisement for ‘become a volunteer in Spain’, she travelled to Santiago de Compostela for four months, and during conversations with pilgrims, she realized that the Camino is therapeutic. She then began to explore the scientific meanings of the Camino de Santiago pilgrimage and is still discovering how this path leads her.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11bb58d4